import Immutable, { Map } from 'immutable'
import { combineActions, handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'
import { RESET_STORE } from 'constants/index'

// action types
export const LICENSEE_APPLICATION_CLEAR_DATA =
  'licenseeApplication/LICENSEE_APPLICATION_CLEAR_DATA'
export const LICENSEE_APPLICATION_FETCH_TABLE_DATA =
  'licenseeApplication/LICENSEE_APPLICATION_FETCH_TABLE_DATA'
export const [
  LICENSEE_APPLICATION_FETCH_TABLE_DATA_SUCCESS,
  LICENSEE_APPLICATION_FETCH_TABLE_DATA_FAILURE,
] = [
  `${LICENSEE_APPLICATION_FETCH_TABLE_DATA}_SUCCESS`,
  `${LICENSEE_APPLICATION_FETCH_TABLE_DATA}_FAILURE`,
]
export const LICENSEE_APPLICATION_DELETE = 'licenseeApplication/DELETE'
export const [
  LICENSEE_APPLICATION_DELETE_SUCCESS,
  LICENSEE_APPLICATION_DELETE_FAILURE,
] = [
  `${LICENSEE_APPLICATION_DELETE}_SUCCESS`,
  `${LICENSEE_APPLICATION_DELETE}_FAILURE`,
]
export const LICENSEE_APPLICATION_CLEAR_STATE_LIST =
  'licenseeApplication/LICENSEE_APPLICATION_CLEAR_STATE_LIST'
export const LICENSEE_APPLICATION_CLEAR_STATE_FORM =
  'licenseeApplication/LICENSEE_APPLICATION_CLEAR_STATE_FORM'
export const LICENSEE_APPLICATION_CLEAR_STATE =
  'licenseeApplication/CLEAR_STATE'
export const LICENSEE_APPLICATION_CHANGE =
  'licenseeApplication/LICENSEE_APPLICATION_CHANGE'
export const LOAD_LICENSEE_APPLICATION_FORM =
  'licenseeApplication/LOAD_LICENSEE_APPLICATION_FORM'
export const LICENSEE_APPLICATION_FETCH_FORM_DATA =
  'licenseeApplication/LICENSEE_APPLICATION_FETCH_FORM_DATA'
export const [
  LICENSEE_APPLICATION_FETCH_FORM_DATA_SUCCESS,
  LICENSEE_APPLICATION_FETCH_FORM_DATA_FAILURE,
] = [
  `${LICENSEE_APPLICATION_FETCH_FORM_DATA}_SUCCESS`,
  `${LICENSEE_APPLICATION_FETCH_FORM_DATA}_FAILURE`,
]

// actions
export const licenseeApplicationClearData = ActionHelper.createActionObj(
  LICENSEE_APPLICATION_CLEAR_DATA,
)
export const licenseeApplicationFetchTableData = ActionHelper.createActionObj(
  LICENSEE_APPLICATION_FETCH_TABLE_DATA,
)
export const licenseeApplicationFetchFormData = ActionHelper.createActionObj(
  LICENSEE_APPLICATION_FETCH_FORM_DATA,
)
export const licenseeApplicationClearStateList = ActionHelper.createActionObj(
  LICENSEE_APPLICATION_CLEAR_STATE_LIST,
)
export const licenseeApplicationDelete = ActionHelper.createActionObj(
  LICENSEE_APPLICATION_DELETE,
)
export const licenseeApplicationClearState = ActionHelper.createActionObj(
  LICENSEE_APPLICATION_CLEAR_STATE,
)
export const licenseeApplicationClearStateForm = ActionHelper.createActionObj(
  LICENSEE_APPLICATION_CLEAR_STATE_FORM,
)
export const licenseeApplicationChange = ActionHelper.createActionObj(
  LICENSEE_APPLICATION_CHANGE,
)

const initialState = Immutable.fromJS({
  licenseeApplicationLoader: true,
  isLoadForm: false,
  tableData: {
    data: [],
    count: 0,
  },
  formData: {
    licenseeApplication: {},
    applications: [],
    licensees: [],
  },
})
const loadingActive = state => state.set('loading', true)

const licenseeApplication = handleActions(
  {
    [combineActions(
      LICENSEE_APPLICATION_DELETE,
      LICENSEE_APPLICATION_FETCH_TABLE_DATA_SUCCESS,
      LICENSEE_APPLICATION_CHANGE,
    )]: loadingActive,
    [combineActions(LICENSEE_APPLICATION_CLEAR_STATE, RESET_STORE)]: () =>
      initialState,
    [LICENSEE_APPLICATION_FETCH_TABLE_DATA_SUCCESS]: (state, action) =>
      state.set('tableData', Map(action.payload)),
    [LOAD_LICENSEE_APPLICATION_FORM]: (state, action) =>
      state.set('isLoadForm', Boolean(action.payload)),
    [LICENSEE_APPLICATION_CLEAR_STATE_LIST]: state =>
      state.set('tableData', initialState.get('tableData')),
    [LICENSEE_APPLICATION_FETCH_FORM_DATA_SUCCESS]: (state, action) =>
      state.set('formData', Map(action.payload)),
    [LICENSEE_APPLICATION_CLEAR_STATE_FORM]: state =>
      state.set('formData', initialState.get('formData')),
    [LICENSEE_APPLICATION_CLEAR_DATA]: () => initialState,
  },
  initialState,
)

export default licenseeApplication
